/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Pricing page components
import FaqCollapse from "layouts/pages/pricing-page/components/FaqCollapse";

function Faq() {
  const [collapse, setCollapse] = useState(false);

  return (
    <MDBox mt={8} mb={6}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <MDTypography variant="h2" align="center" fontWeight="bold" gutterBottom>
            Frequently Asked Questions
          </MDTypography>
          <MDBox mb={2}>
            <MDTypography variant="body2" align="center" color="text">
              A lot of people don&apos;t appreciate the moment until it’s passed. I&apos;m not
              trying my hardest, and I&apos;m not trying to do
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={10}>
          <FaqCollapse
            title="各プランについて教えてください"
            open={collapse === 1}
            onClick={() => (collapse === 1 ? setCollapse(false) : setCollapse(1))}
          >
            「フリープラン」は本サービス登録時に設定されるプランとなります。利用可能な範囲が限定されますが、費用は一切かかりません。トライアルとしてご活用ください。
            「ビジネスプラン」は基本料金と従量料金から構成されるプランとなり、制限なくサービスをご利用できます。データポイントごとに基本料金と従量料金が発生しますが、データ処理を実施しない月は、データポイント数ごとにUS$5でデータを保持することができます。請求は毎月実施され、インボイスページで請求額を確認できます。
            「カスタマイズプラン」は本サービスを自社プラットフォーム上で提供したいお客様のプランとなります。パートナーシップ契約となりますので、詳細はpertnership@enerscale.comまでお問合せください。
          </FaqCollapse>
          <FaqCollapse
            title="従量課金の仕組みについて教えて下さい"
            open={collapse === 2}
            onClick={() => (collapse === 2 ? setCollapse(false) : setCollapse(2))}
          >
            太陽光発電システムの「発電データ期間(1日分あたりUS$0.02)」と「データ転送料金(1日分あたりUS$0.001)」に応じて費用が変わる仕組みになっています。同じデータポイントで最初の計算にかかったコスト内であれば、何度でも計算可能となります。例えば、20年の発電データを用いた場合、基本月額費用US$13.2+従量課金US$146(発電データ期間365日×20年×US$0.02/日)+従量課金US$7.3(データ転送料金365日×20年×US$0.001/日)=US$166.5の請求となりますが、同じ請求月でアップロードされた発電データ期間のメタデータを変更し、再計算しても追加料金を請求することはありません。※基本月額費用は、1データポイントかつデータ計算処理をした請求月に対して、請求となります。
            ただし、同じ請求月で期間を延ばして計算する場合は、追加日数分の従量課金（発電データ期間+データ転送料金）が発生します。また、新しくデータポイントを追加して計算する場合は、請求月に関わらず、基本月額費用US$13.2+従量課金が発生するのでご注意ください。
          </FaqCollapse>
          <FaqCollapse
            title="初月費用が高いのはなぜですか？"
            open={collapse === 3}
            onClick={() => (collapse === 3 ? setCollapse(false) : setCollapse(3))}
          >
            本サービスでは、劣化解析や汚れ解析の評価に必要な気温、日射量、風速などの環境データを利用します。環境データの利用を含めた料金として、初月のみUS$50としております。
          </FaqCollapse>
          <FaqCollapse
            title="データ計算処理を実施しなかった月の費用はいくらですか？"
            open={collapse === 4}
            onClick={() => (collapse === 4 ? setCollapse(false) : setCollapse(4))}
          >
            過去に計算した結果の閲覧のみの場合、データポイントあたり基本月額料金US$5になります。請求月が更新された状況で、発電データ期間に追加日数がなく、変更可能なメタデータを変更して再計算した場合は、データポイントあたり基本月額料金US$13.2が発生しますのでご注意ください。また、本ケースでデータポイントが複数ある場合、再計算したデータポイントのみ、基本月額料金US$13.2の請求となりますので、ご安心ください。例えば、データポイントAとデータポイントBは閲覧のみで、データポイントCを再計算した場合の基本月額料金は、データポイントA＝US$5、データポイントB=US$5、データポイントC=US$13.2で、合計US$23.2がその月の基本月額料金の請求額になります。
          </FaqCollapse>
          <FaqCollapse
            title="環境データはどのようなデータですか？"
            open={collapse === 5}
            onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
          >
            本サービスは信頼性のあるサードパーティのデータベースを利用できる仕組みを構築しており、50を超えるデータソースから100を超える環境データを連携しています。連携している環境データの例を挙げますと、「Radiation=日射量()」「Temperature=気温()」「Wind=風速()」「Humidity=湿度()」「Precipitation=降水量()」「Clouds=雲()」「Air
            motion=空気の動き()」「Sea surface=海面()」「Air quality=空気の質()」「Soil and
            surface=土壌と表面()」などになります。
          </FaqCollapse>
          <FaqCollapse
            title="プラン解約の方法を教えてください"
            open={collapse === 5}
            onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
          >
            プランの解約は、プランページの「現在のプラン」を選択し、「フリープランに戻す」を選択してください。来月分より請求が無料となります。また、次月以降、計算されたデータも削除されてしまうため、ご注意ください。
          </FaqCollapse>
          <FaqCollapse
            title="アカウントの解約方法を教えてください"
            open={collapse === 5}
            onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
          >
            マイページの「アカウントを解約する」を選択してください。アカウントを解約した場合は、本サービスにアクセスできなくなりますので、ご注意ください。
          </FaqCollapse>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Faq;
